import { render, staticRenderFns } from "./RoutesLegends.vue?vue&type=template&id=00deb168&scoped=true&"
import script from "./RoutesLegends.vue?vue&type=script&lang=js&"
export * from "./RoutesLegends.vue?vue&type=script&lang=js&"
import style0 from "./RoutesLegends.vue?vue&type=style&index=0&id=00deb168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00deb168",
  null
  
)

export default component.exports